<template>
  <div>
    <b-row>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >

        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select
              id="perPageSelect"
              v-model="perPage"
              size="sm"
              :options="pageOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="4"
          class="my-1"
      >

        <b-form-group
            class="mb-0"
        >
          <label class="d-inline-block text-sm-left mr-50">Per page</label>
          <b-form-select
              v-model="voucherOption"
              size="sm"
              :options="voucherOptions"
              class="w-50"
          />
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="8"
          class="my-1"
      >
        <b-form-group
            label="Datum"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="sortBySelect"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.from"
                type="text"
                placeholder="DD.MM.YY"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateFromContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          sm="8"
          class="my-1"
      >
        <b-form-group
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                ref="fieldData"
                v-model="date.to"
                type="text"
                placeholder="DD.MM.YY"
                autocomplete="off"
                show-decade-nav
                @keypress="EnterDate($event)"
            />
            <b-input-group-append>
              <b-form-datepicker
                  :date-format-options="{ year: '2-digit', month: '2-digit', day: '2-digit' }"
                  button-only
                  :start-weekday="1"
                  locale="de-DE"
                  color="danger"
                  size="sm"
                  @context="onDateToContext"
              />
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
      <b-col
          md="2"
          class="my-1"
      >
        <b-form-group
            label="Filter"
            label-cols-sm="3"
            label-align-sm="right"
            label-size="sm"
            label-for="filterInput"
            class="mb-0"
        >
          <b-input-group size="sm">
            <b-form-input
                id="filterInput"
                v-model="filter"
                type="search"
                placeholder="Name, Telefon etc."
            />
            <b-input-group-append>
              <b-button
                  :disabled="!filter"
                  @click="filter = ''"
              >
                Leeren
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>

    <b-col cols="12">
      <b-table
          striped
          hover
          responsive
          :items="items"
          :fields="fields"
      >

        <template #cell(Vid)="data">{{ data.item.Vid }}
          <feather-icon
              v-show="data.item.BillNumber != ''"
              icon="LockIcon"
              size="12"
          />
          <b-badge
              v-show="data.item.Canceled != null"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              v-b-tooltip.hover.v-primary
              :title="(data.item.Canceled + ' ('+data.item.CanceledUser+')')"
              variant="warning"
          >Storniert
          </b-badge>
        </template>
        <template #cell(Price)="data">
          <b-badge
              variant="light-info"
          >{{data.item.NetSum}}
          </b-badge>
        </template>
        <template #cell(Info)="data">
          <connected-voucher-badge v-bind:vData="data.item.ConnectedVoucher" />
        </template>
      </b-table>
    </b-col>

  </div>
</template>

<style scoped>

</style>
<script>
import Vue from 'vue'
import { BBadge, BButton, BCol, BDropdown, BDropdownDivider, BDropdownItem, BFormDatepicker, BFormGroup, BFormInput, BFormSelect, BInputGroup, BInputGroupAppend, BRow, BTable } from 'bootstrap-vue'
import ConnectedVoucherBadge from '@/views/extras/ConnectedVoucherBadge.vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  components: {
    BBadge,
    ConnectedVoucherBadge,
    BTable,
    BFormDatepicker,
    BCol,
    BRow,
    BDropdown,
    BFormGroup,
    BInputGroup,
    BInputGroupAppend,
    BDropdownDivider,
    BButton,
    BFormSelect,
    BDropdownItem,
    BFormInput
  },
  mounted() {
    this.LoadList();
  },
  methods: {

    EnterDate(event) {
      if (event.which == 13) {
        this.LoadList()
      }
    },
    onDateFromContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.from = ctx.activeFormatted
        this.LoadList()
      }
    },
    onDateToContext(ctx) {
      if (ctx.selectedDate) {
        // The date formatted in the locale, or the `label-no - date - selected` string
        this.formatted = ctx.selectedFormatted
        // The following will be an empty string until a valid date is entered
        this.selected = ctx.selectedYMD
        this.date.to = ctx.activeFormatted
        this.value = ctx.activeFormatted
        this.LoadList()
      }
    },
    FormatEuro(euro) {
      return this.$options.filters.currency(euro)
    },
    LoadList() {
      this.items = []
      const c1 = (this.currentPage - 1) * this.perPage
      let url = `voucher/ob/list?from=${c1}&count=${this.perPage}`
      if (this.filter && this.filter !== '') {
        url += `&filter=${this.filter}`
      }
      if (this.date.from != '') {
        const date = this.date.from.split('.')
        if (this.date.from.length == 8) {
          url += `&fromDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.date.to != '') {
        const date = this.date.to.split('.')
        if (this.date.to.length == 8) {
          url += `&toDate=${new Date('20' + date[2] + '-' + date[1] + '-' + date[0]).toDateString()}`
        }
      }
      if (this.voucherOption != 0) {
        url += `&voucherOption=${this.voucherOption}`
      }
      this.$http.get(url)
          .then(resp => {
            var sum = 0;
            var count = 0;
            this.totalRows = resp.data.info.fullEntries
            resp.data.list.forEach(i => {
              count++;
              console.log(i.NetSum.replace(" ", "").replace("€", ""))
              sum += parseFloat(i.NetSum.replace(" ", "").replace("€", "").replace(",", "."))
              this.items.push(i)
            })

            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'Info',
                icon: 'CheckIcon',
                text: 'Summe: ('+count+') '+ this.FormatEuro(sum),
                variant: 'success',
              },
            })
          })
          .catch(err => {
            console.error(err)
          })
    },
  },
  data() {
    return {
      perPage: 50,
      pageOptions: [10, 25, 50, 100, 250, 500],
      voucherOption: 0,
      voucherOptions: [{
        text: '',
        value: 0
      },
        {
          text: 'Stornos anzeiegn',
          value: 1
        }],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      date: {
        from: '',
        to: ''
      },
      filter: null,
      filterOn: [],

      fields: [
        {
          key: 'Vid',
          label: 'V-Data',
        },
        {
          key: 'PickupTime',
          label: 'Abholung',
        },
        {
          key: 'Passengers',
          label: 'Personen',
        },
        {
          key: 'Customer',
          label: 'Kunde',
        },
        {
          key: 'PickUpAddress',
          label: 'Adresse',
        },
        {
          key: 'DestinationAddress',
          label: 'Ziel',
        },
        {
          key: 'Price',
          label: 'Preis',
        },
        {
          key: 'Info',
          label: 'Info',
        },
      ],
      items: [],
    }
  }
}
</script>